<template>
    <div class="row">
        <div class="col-6">
            <label for="inputDataInicio">Data Inicial</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataInicio"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input :type="type" :id="`inputDataInicio`" name="startDate" ref="startDate" v-model="startDate" class="form-control" aria-label="DataInicio" aria-describedby="dataInicio" :required="required">
            </div>
        </div>
        <div class="col-6">
            <label for="inputDataFim">Data Final</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="dataFim"><i class="fas fa-calendar-alt fa-fw"></i></span>
                </div>
                <input :type="type" :id="`inputDataFim`" name="endDate" ref="endDate" v-model="endDate" class="form-control" aria-label="DataFim" aria-describedby="dataFim" :required="required">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'date',
            },
            id: String,
            autofill: {
                type: String,
                default: 'monthly'
            },
            required: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                startDate: '',
                endDate: ''
            }
        },
        mounted() {
            ;
            switch(this.autofill){
                case 'onlyToday':
                    var now = moment().format(this.inputFormat().initialDate);
                    $('input[name=startDate]').val(now);
                    $('input[name=endDate]').val(now);

                    this.startDate = '';
                    this.endDate = '';
                break;
                case 'monthly':
                    var firstOfTheMonth = moment().format(this.inputFormat().initialDate)
					var now = moment().format(this.inputFormat().finalDate)

                    $('input[name=startDate]').val(firstOfTheMonth);
                    $('input[name=endDate]').val(now);

                    this.startDate = '';
                    this.endDate = '';
                break;
                case 'initialToday':
                    var now = moment().format(this.inputFormat().initialDate);
                    var lastOfTheMonth = moment().endOf('month').format(this.inputFormat().finalDate);

                    $('input[name=startDate]').attr('min', now).val(now);
                    $('input[name=endDate]').attr('min', now).val(lastOfTheMonth);

                    this.startDate = '';
                    this.endDate = '';
                break;
            }
        },

        methods: {
            inputFormat(){
                var format = new Array();
                format['date'] = () => {
                    const initialDate = 'YYYY-MM-DD'
                    const finalDate = 'YYYY-MM-DD'
                    return {initialDate, finalDate}
                };

                format['datetime-local'] = () => {
                    const initialDate = this.autofill == 'montly' ? 'YYYY-MM-01T00:00' : 'YYYY-MM-DDT00:00'
                    const finalDate = 'YYYY-MM-DDTHH:mm'
                    return {initialDate, finalDate}
                };

                format['time'] = () => {
                    const initialDate = 'HH:mm'
                    const finalDate = 'HH:mm'
                    return {initialDate, finalDate}
                };

                format['month'] = () => {
                    const initialDate = 'YYYY-MM'
                    const finalDate = 'YYYY-MM'
                    return {initialDate, finalDate}
                };
                const res = format[this.type]();
                return res;
            }
        }
    }
</script>
